export default __webpack_public_path__ + "static/og-image-f419ea4134d08287b70637e60eebb2fb.jpg";